var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginPatternRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 836,
    height: 444,
    viewBox: "0 0 836 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 836,
    height: 444,
    fill: "#F5F5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.268 68.0328C963.297 -122.143 1643.17 -71.4624 1651.31 366.096C1659.45 803.655 1291.03 734.221 947.225 873.045C603.419 1011.87 29.4178 943.896 21.2778 506.338C21.2748 81.1348 416.956 454.992 783.268 68.0328Z",
    fill: "#8AD657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.405 14.7548C902.405 14.7548 833.44 104.996 782.084 167.357C730.727 229.718 670.568 263.467 670.568 263.467C670.568 263.467 550.247 335.126 471.745 390.39C393.243 445.655 548.779 640.569 548.779 640.569",
    stroke: "#0173BC",
    strokeWidth: 11.7386
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 836,
    height: 444,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPatternRight);
export default __webpack_public_path__ + "static/media/login-pattern-right.512fac7f68fe15eb71367bf23046028f.svg";
export { ForwardRef as ReactComponent };